import { render, staticRenderFns } from "./PredictionTableForm.vue?vue&type=template&id=6fd47aa8&scoped=true&"
import script from "./PredictionTableForm.vue?vue&type=script&lang=js&"
export * from "./PredictionTableForm.vue?vue&type=script&lang=js&"
import style0 from "./PredictionTableForm.vue?vue&type=style&index=0&id=6fd47aa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd47aa8",
  null
  
)

export default component.exports